<template>
  <div class="cart-dropdown">
    <span class="">Qty:</span>

    <AppDropdown class="cart-checkout-dropdown">
      <template #trigger>
        <div
          class="text-lg dropdown-trigger border-0 md:!border-b-2 border-gray w-18 h-full flex items-center justify-between hover:bg-[#D4E8F4] py-1.5"
        >
          <span class="pl-4 block">
            {{ quantity }}
          </span>

          <FontAwesomeIcon
            :icon="faCaretDown"
            class="text-sm -mt-0.5 mr-2 duration-200"
          />
        </div>
      </template>

      <AppDropdownItem
        v-for="i in 5"
        :key="i"
        class="text-left"
        @click="quantity = i; handleUpdatingCartItem(item)"
      >
        {{ i }}
      </AppDropdownItem>
    </AppDropdown>
  </div>
</template>

<script setup>

import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { AppDropdown, AppDropdownItem } from '@/components/app';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useCartStore } from '@/store';
import { ref } from 'vue';

const cartStore = useCartStore();

const props = defineProps({
  item: {
    type: Object,
    default: () => {
    },
  },
});

const quantity = ref(props.item.quantity);

const handleUpdatingCartItem = async (item) => {

  const formData = {
    'style': item.style,
    'delivery': item.delivery,
    'size': item.size,
    'quantity': quantity.value,
  };

  await cartStore.updateItem(formData, item.id);
};
</script>
